import React from 'react';
import FormErrors from "./form_errors";
import Reaptcha from "reaptcha";
import {_t} from "../../../js/app/common/utils/locale";

export default class FormRecaptcha extends React.Component {

    render() {
        return (
            <div className="cluster__form-group">
                <div className="form-group">
                    <label className="label" htmlFor={this.props.name}>{_t(this.props.label)}</label>
                    <Reaptcha
                        className={(this.props.errors ? 'is-invalid' : '')}
                        sitekey={this.props.recaptchaKey}
                        onVerify={this.props.onVerify}
                    />
                    <FormErrors errors={this.props.errors} />
                </div>
            </div>
        );
    }

}